import type { FaireProductEntity } from "../../entity_types/product";

export const p_rmwq9jrbr9: FaireProductEntity = {
  token: "p_rmwq9jrbr9",
  type: "product",
  name: "Body Ache Relief Wellness Oil",
  brandToken: "b_cev7opt9ab",
  brandName: "Nature's Inventory",
  imageUrl:
    "https://cdn.faire.com/fastly/4346a15f6d918b4fc8f296f250502a25c1ecb011dc7db4807edef8b0947b2441.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.06,
  description:
    "\nCustomers have called this oil “Comfort in a bottle.” The warming action of ginger essential oil combined with the therapeutic qualities of eucalyptus, rosemary, and cinnamon pack a powerful punch against body aches and pains. Just massaging this oil into your muscles will soothe that dull ache and leave your body feeling comfortable again.\n\n \n\n INGREDIENTS DIRECTIONS \n Cocus Nucifera (fractionated coconut oil), Vitis vinifera (grapeseed oil), eucalyptus globules (organic eucalyptus essential oil), rosmarinus officinalis (organic rosemary essential oil), cinnamomum zeylanicum (organic cinnamon essential oil) & zingiber officinale (organic ginger essential oil).  Shake before use. Apply liberally to any muscle as often as needed. \n \n",
  tags: [],
  msrpDollars: 22.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:45.140Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
